<template>
  <div class="alarm-handler-page">
    <div class="alarm-handler-card">
      <div class="alarm-handler-header">
        <div class="breadcrumb-row">
          <el-breadcrumb separator=">" class="alarm-breadcrumb">
            <el-breadcrumb-item>
              <a @click="goBack" class="breadcrumb-link">告警设置</a>
            </el-breadcrumb-item>
            <el-breadcrumb-item>处理人员</el-breadcrumb-item>
          </el-breadcrumb>
          <el-button size="small" class="alarm-handler-btn-back" @click="goBack">返回</el-button>
        </div>
        <div class="alarm-handler-divider"></div>
        <div class="alarm-handler-toolbar">
          <div class="alarm-handler-actions">
            <el-button size="small" class="alarm-handler-btn-add" @click="handleAdd"><i class="el-icon-plus"></i>添加</el-button>
            <el-button size="small" class="alarm-handler-btn-refresh" title="刷新" @click="fetchList"><i class="el-icon-refresh"></i></el-button>
          </div>
          <div class="alarm-handler-search-group">
            <el-input v-model="searchForm.keyword" size="small" clearable placeholder="请输入" class="alarm-handler-search-input" @keyup.enter.native="handleSearch" />
            <el-button size="small" type="primary" class="alarm-handler-search-btn" @click="handleSearch">搜索</el-button>
          </div>
        </div>
      </div>

      <div class="alarm-handler-table-section">
        <el-table v-loading="loading" :data="tableData" style="width: 100%" :header-cell-style="headerCellStyle" :cell-style="cellStyle">
          <el-table-column prop="communityName" label="所在小区" min-width="150" show-overflow-tooltip />
          <el-table-column prop="staffId" label="处理人员ID" min-width="150" show-overflow-tooltip />
          <el-table-column prop="staffName" label="处理人员名称" min-width="130" show-overflow-tooltip />
          <el-table-column prop="alarmType" label="告警类型" min-width="120" show-overflow-tooltip />
          <el-table-column prop="status" label="状态" min-width="90">
            <template slot-scope="scope">
              <span :class="['status-tag', getStatusClass(scope.row.status)]">{{ scope.row.status }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="说明" min-width="150" show-overflow-tooltip />
          <el-table-column prop="createTime" label="创建时间" min-width="160" show-overflow-tooltip />
          <el-table-column label="操作" min-width="100" fixed="right">
            <template slot-scope="scope">
              <div class="action-group">
                <a class="action-link danger" @click="handleDelete(scope.row)">删除</a>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="alarm-handler-pagination">
        <span class="pagination-total">共{{ pagination.total }}条</span>
        <el-pagination
          :current-page="pagination.page"
          :page-size="pagination.row"
          layout="prev, pager, next"
          :total="pagination.total"
          @current-change="handlePageChange"
        />
        <span class="pagination-size-text">{{ pagination.row }}条/页</span>
      </div>
    </div>

    <add-alarm-handler ref="addAlarmHandler" @success="fetchList" />
  </div>
</template>

<script>
import AddAlarmHandler from '@/components/inspection/AddAlarmHandler'
import { listAlarmHandlers, deleteAlarmHandler } from '@/api/inspection/alarmSettingApi'

export default {
  name: 'AlarmHandlerList',
  components: { AddAlarmHandler },
  data() {
    return {
      loading: false,
      searchForm: { keyword: '' },
      tableData: [],
      pagination: { page: 1, row: 10, total: 0 },
      filterParams: { communityId: '', alarmTypeCd: '' }
    }
  },
  mounted() {
    // 从路由参数获取筛选条件
    const { communityId, alarmTypeCd } = this.$route.query
    if (communityId) this.filterParams.communityId = communityId
    if (alarmTypeCd) this.filterParams.alarmTypeCd = alarmTypeCd
    this.fetchList()
  },
  methods: {
    goBack() {
      this.$router.push('/pages/inspection/alarmSetting')
    },
    async fetchList() {
      this.loading = true
      try {
        const params = {
          page: this.pagination.page,
          row: this.pagination.row
        }
        // 添加筛选条件
        if (this.filterParams.communityId) params.communityId = this.filterParams.communityId
        if (this.filterParams.alarmTypeCd) params.alarmTypeCd = this.filterParams.alarmTypeCd
        if (this.searchForm.keyword) params.keyword = this.searchForm.keyword

        const res = await listAlarmHandlers(params)
        this.tableData = res.data
        this.pagination.total = res.total
      } catch (error) {
        this.$message.error(error.message || '获取列表失败')
      } finally {
        this.loading = false
      }
    },
    handleSearch() { this.pagination.page = 1; this.fetchList() },
    handlePageChange(page) { this.pagination.page = page; this.fetchList() },
    handleAdd() {
      // 传递筛选参数到添加弹窗
      this.$refs.addAlarmHandler.open({
        communityId: this.filterParams.communityId,
        alarmTypeCd: this.filterParams.alarmTypeCd
      })
    },
    async handleDelete(row) {
      try {
        await this.$confirm('确定删除该处理人员吗？', '提示', { type: 'warning' })
        await deleteAlarmHandler({ handlerId: row.handlerId })
        this.$message.success('删除成功')
        this.fetchList()
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error(error.message || '删除失败')
        }
      }
    },
    getStatusClass(status) {
      return status === '启用' ? 'status-active' : 'status-inactive'
    },
    headerCellStyle() {
      return { background: '#F5F8FC', color: '#6A7282', fontWeight: 500, fontSize: '13px', borderBottom: 'none', height: '48px' }
    },
    cellStyle({ rowIndex }) {
      return { background: rowIndex % 2 === 1 ? '#F8FBFF' : '#FFFFFF', color: '#333333', fontSize: '14px', borderBottom: '1px solid #F0F4FA', height: '52px' }
    }
  }
}
</script>

<style scoped>
.alarm-handler-page { height: calc(100vh - 60px); background: #EBF2FA; padding: 16px; overflow: hidden; display: flex; flex-direction: column; }
.alarm-handler-card { background: #FFFFFF; border-radius: 12px; box-shadow: 0 2px 8px rgba(0,0,0,0.06); display: flex; flex-direction: column; height: 100%; overflow: hidden; }
.alarm-handler-header { padding: 24px 24px 0; flex-shrink: 0; }
.breadcrumb-row { display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px; }
.alarm-breadcrumb { font-size: 14px; }
.alarm-breadcrumb >>> .el-breadcrumb__item { color: #6A7282; }
.alarm-breadcrumb >>> .el-breadcrumb__item:last-child { color: #1D2129; font-weight: 500; }
.breadcrumb-link { color: #0E76FF; cursor: pointer; text-decoration: none; }
.breadcrumb-link:hover { text-decoration: underline; }
.alarm-handler-btn-back { border-radius: 8px; height: 32px; padding: 0 16px; }
.alarm-handler-title { font-size: 18px; font-weight: 600; color: #1D2129; line-height: 26px; }
.alarm-handler-divider { height: 1px; background: #DCE6F5; margin: 16px 0; }
.alarm-handler-toolbar { display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px; }
.alarm-handler-actions { display: flex; gap: 8px; }
.alarm-handler-btn-add { background: #0E76FF; color: #FFFFFF; border: none; border-radius: 10px; height: 36px; padding: 0 16px; font-weight: 500; }
.alarm-handler-btn-add:hover { background: #0D6CE8; }
.alarm-handler-btn-refresh { width: 36px; height: 36px; padding: 0; border-radius: 10px; border: 1px solid #DCE6F5; background: #FFFFFF; color: #6A7282; }
.alarm-handler-btn-refresh:hover { background: #F5F8FC; }
.alarm-handler-search-group { display: flex; gap: 8px; }
.alarm-handler-search-input { width: 200px; }
.alarm-handler-search-btn { height: 36px; padding: 0 20px; border-radius: 10px; }
.alarm-handler-table-section { flex: 1; overflow: auto; padding: 0 24px; }
.action-group { display: flex; align-items: center; gap: 12px; }
.action-link { color: #0E76FF; cursor: pointer; font-size: 14px; text-decoration: none; }
.action-link:hover { text-decoration: underline; }
.action-link.danger { color: #F53F3F; }
.status-tag { padding: 2px 8px; border-radius: 4px; font-size: 12px; }
.status-active { background: #E8F5E9; color: #4CAF50; }
.status-inactive { background: #FFEBEE; color: #F44336; }
.alarm-handler-pagination { display: flex; align-items: center; justify-content: flex-end; gap: 16px; padding: 16px 24px; border-top: 1px solid #F0F4FA; flex-shrink: 0; }
.pagination-total { color: #6A7282; font-size: 14px; }
.pagination-size-text { color: #6A7282; font-size: 14px; }
</style>
